"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var FilterPharmacySearchResults = function FilterPharmacySearchResults(_ref) {
  var form = _ref.form,
    searchString = _ref.searchString,
    onSearch = _ref.onSearch,
    search = _ref.search,
    setSearchString = _ref.setSearchString;
  var getFieldDecorator = form.getFieldDecorator;
  return /*#__PURE__*/_react.default.createElement(_form.default, null, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label material-form-item"
  }, getFieldDecorator('filter')( /*#__PURE__*/_react.default.createElement(_input.default, {
    value: searchString,
    addonAfter: 'Filter by pharmacy name, address',
    type: "text",
    onChange: function onChange(e) {
      var value = e.target.value;
      if (onSearch === _utils.noop) {
        search(value);
      } else {
        onSearch();
      }
      setSearchString(value);
    }
  }))));
};
var _default = _form.default.create({
  name: 'FilterPharmacySearchResults'
})(FilterPharmacySearchResults);
exports.default = _default;